<div class="ec2-container">
  <h4>EC2 Instances</h4>

  <div class="toolbar">
    <button nz-button nzType="primary" (click)="openAddModal()">
      Add instance
    </button>
    <button
      nz-button
      nzType="default"
      [nzLoading]="isLoading"
      (click)="loadInstances()"
    >
      Refresh
    </button>
  </div>

  <nz-table
    class="styled-table"
    #table
    [nzData]="instances"
    [nzLoading]="isLoading"
    nzSize="small"
    [nzShowPagination]="instances.length > 10"
    nzPageSize="10"
    [nzNoResult]="emptyData"
  >
    <thead>
      <tr>
        <th>Name</th>
        <th>Instance ID</th>
        <th>Region</th>
        <th>State</th>
        <th nzWidth="280px">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of table.data">
        <td>{{ row.name }}</td>
        <td><code>{{ row.id }}</code></td>
        <td>{{ row.region }}</td>
        <td>
          <nz-badge
            [nzStatus]="row.state === 'running' ? 'success' : (row.state === 'stopped' ? 'default' : 'processing')"
            [nzText]="row.state || '—'"
          ></nz-badge>
        </td>
        <td>
          <span class="action-buttons">
            <button
              nz-button
              nzType="primary"
              nzSize="small"
              [disabled]="!canStart(row)"
              [nzLoading]="actionLoading[row.id]"
              (click)="changeState(row, 'start')"
            >
              Start
            </button>
            <button
              nz-button
              nzSize="small"
              [disabled]="!canStop(row)"
              [nzLoading]="actionLoading[row.id]"
              (click)="changeState(row, 'stop')"
            >
              Stop
            </button>
            <button
              nz-button
              nzSize="small"
              [disabled]="!canReboot(row)"
              [nzLoading]="actionLoading[row.id]"
              (click)="changeState(row, 'reboot')"
            >
              Reboot
            </button>
            <button
              *ngIf="isComputeAdmin"
              nz-button
              nzSize="small"
              (click)="openManageUsers(row)"
            >
              Manage users
            </button>
            <button
              *ngIf="isComputeAdmin"
              nz-button
              nzSize="small"
              nzDanger
              nz-popconfirm
              nzPopconfirmTitle="Remove this instance from the registry? This does not terminate the EC2 instance in AWS."
              [nzLoading]="actionLoading[row.id]"
              (nzOnConfirm)="deleteInstance(row)"
            >
              Delete
            </button>
          </span>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>

<ng-template #emptyData>
  <nz-empty nzNotFoundContent="No EC2 instances. Add one to get started."></nz-empty>
</ng-template>

<nz-modal
  [(nzVisible)]="addModalVisible"
  nzTitle="Add EC2 instance"
  nzOkText="Add"
  >
  <!-- (nzOnCancel)="closeAddModal()"
  (nzOnOk)="submitAdd()" -->
  <ng-container *nzModalContent>
    <p>Register an existing EC2 instance by its ID and region.</p>
    
    <form nz-form [formGroup]="addForm">
      <nz-form-item class="floating-label">
        <nz-form-label nzRequired nzFor="instanceID" [nzNoColon]="true">Instance ID</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input placeholder="e.g. i-0123456789abcdef0" id="instanceID" required formControlName="id" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="floating-label">
        <nz-form-label nzRequired nzFor="region" [nzNoColon]="true">Region</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input placeholder="Region" id="region" required formControlName="region" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="floating-label">
        <nz-form-label nzRequired nzFor="name" [nzNoColon]="true">Name</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input placeholder="Name" id="name" required formControlName="name" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="floating-label">
        <nz-form-label nzFor="description" [nzNoColon]="true">Description</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input placeholder="Description" id="description" required formControlName="description" />
        </nz-form-control>
      </nz-form-item>
    </form>

    <!-- <div class="form-row">
      <span class="label">Instance ID <span class="required">*</span></span>
      <input
        nz-input
        [(ngModel)]="addForm.id"
        placeholder="e.g. i-0123456789abcdef0"
      />
    </div>
    <div class="form-row">
      <span class="label">Region</span>
      <input
        nz-input
        [(ngModel)]="addForm.region"
        placeholder="us-east-1"
      />
    </div>
    <div class="form-row">
      <span class="label">Name</span>
      <input
        nz-input
        [(ngModel)]="addForm.name"
        placeholder="Display name"
      />
    </div>
    <div class="form-row">
      <span class="label">Description</span>
      <input
        nz-input
        [(ngModel)]="addForm.description"
        placeholder="Optional description"
      />
    </div> -->
  </ng-container>

  <ng-container *nzModalFooter>
    <div style="display: flex; justify-content: space-between;">
      <div>
        <button nz-button (click)="closeAddModal()" [disabled]="loading">Cancel</button>
        <button nz-button (click)="submitAdd()" [disabled]="!addForm.valid || loading" nzType="primary">Add</button>
      </div>
    </div>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="manageUsersVisible"
  nzTitle="Manage instance users"
  (nzOnCancel)="closeManageUsers()"
  (nzOnOk)="saveManageUsers()"
  nzOkText="Save"
  [nzOkLoading]="instanceUsersLoading"
>
  <ng-container *nzModalContent>
    <p *ngIf="managingInstance">
      Users with access to <strong>{{ managingInstance.name }}</strong> ({{ managingInstance.id }}).
    </p>
    <div *ngIf="instanceUsersLoading && selectedUserIds.length === 0" class="loading-row">
      Loading users…
    </div>
    <div *ngIf="!instanceUsersLoading" class="form-row">
      <span class="label">Users with access</span>
      <nz-select
        [(ngModel)]="selectedUserIds"
        nzMode="multiple"
        nzPlaceHolder="Select users"
        style="width: 100%;"
      >
        <nz-option
          *ngFor="let u of allUsers"
          [nzLabel]="u.email"
          [nzValue]="u.id"
        ></nz-option>
      </nz-select>
    </div>
  </ng-container>
</nz-modal>
